import auth from "./auth";
import api from "./api";

const SERVICE_URL = "survey-service/v2/api/cms/survey/";
const SERVICE_URL_V3 = "survey-service/v3/api/cms/survey/";

export default {
    getSurveys({ page, params }) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}list/${page}`, params, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getSurvey(uuid) {
        return new Promise((resolve, reject) => {
            api.get(`${SERVICE_URL}details/${uuid}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    createSurvey(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL_V3}create`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateSurvey(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL_V3}update`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    duplicateSurvey(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL_V3}duplicate`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteSurvey(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}delete`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getSurveyUrl(uuid) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}public/url`, uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    createPage(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}page/create`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updatePage(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}page/update`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deletePage(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}page/delete`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    createQuestion(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL_V3}question/create`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateQuestion(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL_V3}question/update/${payload.question_uuid}`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteQuestion(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                `${SERVICE_URL}question/delete/${uuid}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getQuestions(page_uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                `${SERVICE_URL}question/page/${page_uuid}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateQuestionSort(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL}question/sort/${payload.question_uuid}`,
                payload.params,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getPageDetails(uuid) {
        return new Promise((resolve, reject) => {
            api.get(`${SERVICE_URL}page/details/${uuid}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveDesign(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}design/save`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updatePageSort(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL}page/update-sorting`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getDesignDetails(id) {
        return new Promise((resolve, reject) => {
            api.get(`${SERVICE_URL}design/details/${id}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getSurveyExportFile(uuid) {
        return new Promise((resolve, reject) => {
            api.get(`${SERVICE_URL}export/${uuid}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    import(uuid, answers) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}import/${uuid}`, answers, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
